AuthRoute = require 'mixins/authenticated-route'

App.ReportsRoute = Em.Route.extend AuthRoute,
  env: Em.inject.service('environment')

  model: ->
    model = @store.find('report').then((reports) =>
      # Как-то странно работает LSAdapter приходится резолвить промис
      Ember.RSVP.resolve(reports.content).then((reports) =>
        if reports.length
          reports[0]
        else
          @store.createRecord('report')
      )
    )

    return Em.RSVP.hash(
      reportSchemas: @store.find('report_schema').then (data) => data.filter (item) => if item.id == "couriers" then @get('env.features.courierPassedDistancesTracking') else true
      model: model
    )

  afterModel: (hash) ->
    hash.model.get('reportSchema')
    hash.model.get('filters')


  setupController: (controller, hash) ->
    controller.setProperties(hash)
